<template>
  <svg
    viewBox="0 0 14 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 12.875C6.51562 12.875 6.125 12.4844 6.125 12V10C6.125 9.51564 6.51562 9.12501 7 9.12501C7.48438 9.12501 7.875 9.51564 7.875 10V12C7.875 12.4844 7.48438 12.875 7 12.875ZM14 7.50001V14.5C14 15.3281 13.3281 16 12.5 16H1.5C0.671875 16 0 15.3281 0 14.5V7.50001C0 6.67189 0.671875 6.00001 1.5 6.00001H2.5V4.50001C2.5 2.01564 4.525 -0.00623555 7.0125 1.4451e-05C9.5 0.00626445 11.5 2.05626 11.5 4.54376V6.00001H12.5C13.3281 6.00001 14 6.67189 14 7.50001ZM4 6.00001H10V4.50001C10 2.84689 8.65312 1.50001 7 1.50001C5.34688 1.50001 4 2.84689 4 4.50001V6.00001ZM12.5 7.50001H1.5V14.5H12.5V7.50001Z"
    />
  </svg>
</template>
